import React, {Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";

import {fetchUserFollowings, resetUserFollowings} from "../../../../creators/user.followings";

import UserStatList from "../../../components/UserStatList";
import {SpinLoader} from "../../../components/Loader";
import Modal from "../../../components/Modal";

class Following extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleUserStatListFollowing: false
        };


    }

    componentDidMount() {
        this.props.fetchUserFollowings(this.props.user._id, {limit : false});
    }

    componentWillUnmount() {
        this.props.resetUserFollowings();
    }

    render() {
        return (
            <Fragment>
                <div
                    className={`following-count column my-16 ${this.props.userFollowingTotal >= 1 ? 'cursor-pointer' : ''}`}
                    onClick={() => this.props.userFollowingTotal >= 1 && this.setState({toggleUserStatListFollowing: true})}>
                    {!this.props.userFollowingInitialized ? (
                        <span className="followers-number">0</span>
                    ) : (
                        <Fragment>
                            {!this.props.userFollowingLoading ?
                                <span className="followers-number">{this.props.userFollowingTotal || 0}</span> :
                                <SpinLoader className={"small"}/>}
                        </Fragment>
                    )}
                    <span className="followers-text">suivis</span>
                </div>
                <Modal toggle={this.state.toggleUserStatListFollowing}
                       handleClose={() => this.setState({toggleUserStatListFollowing: false})}>
                    <UserStatList
                        type="following"
                        following={this.props.userFollowing}
                        handleClose={() => this.setState({toggleUserStatListFollowing: false})}
                        User={this.props.user}
                    />
                </Modal>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userFollowing: state.userFollowings.data,
        userFollowingLoading: state.userFollowings.loading,
        userFollowingInitialized: state.userFollowings.initialized,
        userFollowingTotal: state.userFollowings.total
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserFollowings,
    resetUserFollowings
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Following);